// app/javascript/projects/components/ShareToCompare.jsx

import React from 'react';
import GenericOnboardingMessage from './GenericOnboardingMessage';
import { useCollabModal } from '../../contexts/CollabModalContext';

function ShareToCompare() {
  const { showCollabModal } = useCollabModal();

  const onClick = () => {
    showCollabModal();
  }

  return (<GenericOnboardingMessage
    header='Coding Comparison'
    body='Compare how different people coded the same transcript.'
    secondBody='Share project to get started.'
    buttonText="Share Project"
    onClick={onClick}
    intercomArticleId={process.env['INTERCOM_ARTICLE_CODING_COMPARISON']}
    helpArticleText='Learn more about coding comparison.'
  />)
}

export default ShareToCompare;
